import { FC } from "react";
import { PathRouteProps } from "react-router-dom";

enum Pages {
    Login,
    ConfirmOTP,
    Profile,
    Account,
    ChangePhone,
    Dashboard,
    Assignments,
    AssignmentsTask,
    AssortmentMatrix,
    DMP,
    PromoTagPhotos,
    WorkPlan,
    AboutPoint,
    AboutPointVerifyAddress,
    AboutPointContracts,
    AboutPointContract,
    AboutPointShelves,
    AboutPointPlan,
    TakeDebt,
    RemainingGoods,
    RejectProducts,
    UnplannedMarkets,
    Upsells,
    CheckoutUpsells,
    ContractCreation,
    ProductCard,
    FAQBlock,
    SetGeoLocation,
    AddPhoto,
    ShelfSize,
    Checkout,
    OrderDetails,
    // AddProducts,
    MainCheckout,
    MainCheckoutDetails,
    PromoCatalog,
    //SV
    Team,
    MemberInfo,
    RouteManagement,
    NewRouteSV,
    EditRouteSV,
    AddMarketSV,
    AddNewMarketSV,
    MainCheckoutSV,
    AgentCheckoutSV,
    MarketCreateSV,
    WorkPlanSV,
    //HR
    TeamHR,
    MemberInfoHR,
    AddMemberToTeamHR,
    AddNewUserHR,
    UpdateMarketInfo,
    Admin,
    SalaryKPI,
    MotivationKPI,
    //KAM
    RouteManagementMyRoute,
}

type PathRouteCustomProps = {
    title?: string;
    component: FC;
    isPrivate: boolean;
    allowedRoles?: string[];
};

type Routes = Record<Pages, PathRouteProps & PathRouteCustomProps>;

export type { Routes };
export { Pages };
